/** CSS contract: css-library/components/01-leaves/text.css. */
import type { Ref } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface TextProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'default' | 'lg';
  isFilled?: boolean;
  mark?: ReactNode;
  markId?: string;
}

export function Text(
  { ref, className, type = 'text', size = 'default', isFilled = false, mark, markId, ...rest }: TextProps & { ref?: Ref<HTMLInputElement> },
) {
  const input = (
    <input
      ref={ref}
      type={type}
      className={cx('text', size === 'lg' && 'text--lg', isFilled && 'is-filled', className)}
      {...rest}
    />
  );
  // A null mark still reserves the status slot so the text does not jump.
  if (mark === undefined) return input;
  return (
    <span className="text-with-mark">
      {input}
      {mark != null && mark !== false && (
        <span className="text-mark" id={markId}>
          {mark}
        </span>
      )}
    </span>
  );
}
